import { useMemo, useState } from "react";
import { useParams } from "react-router-dom";

import { Loading } from "@/shared/components/Loading/Loading";
import TableHeader from "@/shared/components/TableHeader/TableHeader";
import { sortElements } from "@/shared/utils/array/sort.utils";

import { useGetScaleAnalyses } from "./use-get-scale-analyses.hook";
import { ScaleAnalysisEditor } from "./ScaleAnalysisEditor";

import commonStyle from "../TestSettings/style.module.css";

export function Scales() {
  const { test_id: testId } = useParams();
  const { scales, availableLocales, isLoading, refresh } = useGetScaleAnalyses(testId);
  const [search, setSearch] = useState("");

  const filteredScales = useMemo(() => {
    const term = search.trim().toLowerCase();
    return scales
      .filter((scale) => !term || scale.name.toLowerCase().includes(term) || scale.abbr.toLowerCase().includes(term))
      .sort((a, b) => sortElements(a.name, b.name));
  }, [scales, search]);

  if (isLoading) {
    return <Loading />;
  }

  return (
    <div className={commonStyle.innerTabsContainer}>
      <TableHeader tableName={""} handleSearchChange={(e) => setSearch(e.target.value)} />
      {filteredScales.map((scale) => (
        // Include scaleAnalysisId in the key so authoring a scale that had none, or converting one
        // to test-specific — both of which swap the row in effect — remounts the editor with the
        // fresh content instead of keeping stale local state.
        <ScaleAnalysisEditor
          key={`${scale.scaleId}-${scale.scaleAnalysisId}`}
          scale={scale}
          testId={Number(testId)}
          availableLocales={availableLocales}
          onRowChanged={refresh}
        />
      ))}
    </div>
  );
}
